import BidTable from './BidTable';

export default BidTable;
